import request from '@/utils/request'
// 用户信息
export function userInfo(data) {
    return request({
        url:'/netbar/api/user/v1/user_information',
        method:'post',
        data
    })
}
// 人员核实
export function qrcodeCheck(data) {
    return request({
        url:'/netbar/api/personnel_to_verify/v1/select_user_information',
        method:'post',
        data
    })
}
// 用户信息管理
export function userList(data) {
    return request({
        url:'/netbar/api/netbar/v1/select_user_list_by_id',
        method:'post',
        data
    })
}
// 删除用户
export function deleteUser(data) {
    return request({
        url:'/netbar/api/netbar/v1/del',
        method:'post',
        data
    })
}
// 输入手机号查询用户信息
export function selectUserInfoPhone(data) {
    return request({
        url:'/netbar/api/user/v1/select_user_by_login_phone',
        method:'post',
        data
    })
}
// 添加用户
export function addUser(data) {
    return request({
        url:'/netbar/api/netbar/v1/insert',
        method:'post',
        data
    })
}
